import React from 'react';
import { Wifi, WifiOff, Loader2, CheckCircle, AlertCircle } from 'lucide-react';

interface RealtimeStatusIndicatorProps {
  isConnected: boolean;
  hasActiveSubscription: boolean;
  isPreOrder: boolean;
  loading: boolean;
  error: string | null;
  className?: string;
}

export const RealtimeStatusIndicator: React.FC<RealtimeStatusIndicatorProps> = ({
  isConnected,
  hasActiveSubscription,
  isPreOrder,
  loading,
  error,
  className = ''
}) => {
  const getStatusColor = () => {
    if (error) return 'text-red-600 bg-red-50 border-red-200';
    if (loading) return 'text-blue-600 bg-blue-50 border-blue-200';
    if (!isConnected) return 'text-orange-600 bg-orange-50 border-orange-200';
    if (isPreOrder) return 'text-purple-600 bg-purple-50 border-purple-200';
    if (hasActiveSubscription) return 'text-green-600 bg-green-50 border-green-200';
    return 'text-gray-600 bg-gray-50 border-gray-200';
  };

  const getStatusIcon = () => {
    if (error) return <AlertCircle className="w-4 h-4" />;
    if (loading) return <Loader2 className="w-4 h-4 animate-spin" />;
    if (!isConnected) return <WifiOff className="w-4 h-4" />;
    if (isPreOrder) return <CheckCircle className="w-4 h-4" />;
    if (hasActiveSubscription) return <CheckCircle className="w-4 h-4" />;
    return <Wifi className="w-4 h-4" />;
  };

  const getStatusText = () => {
    if (error) return 'Connection Error';
    if (loading) return 'Loading...';
    if (!isConnected) return 'Reconnecting...';
    if (isPreOrder) return 'Pre-Order Active';
    if (hasActiveSubscription) return 'Subscription Active';
    return 'Real-time Connected';
  };

  return (
    <div className={`inline-flex items-center space-x-2 px-3 py-2 rounded-lg border text-sm font-medium ${getStatusColor()} ${className}`}>
      {getStatusIcon()}
      <span>{getStatusText()}</span>
      {isConnected && !loading && !error && (
        <div className="w-2 h-2 bg-current rounded-full animate-pulse"></div>
      )}
    </div>
  );
};

export default RealtimeStatusIndicator;